import type { StatusIntent } from '@/theme/tokens';

/** Arrowhead ids + fill colours (CSS vars). Non-JSX so markers.tsx stays component-only. */
export const MARKERS: Array<[string, string]> = [
  ['seq', 'var(--ol-text-tertiary)'],
  ['positive', 'var(--ol-positive)'],
  ['attention', 'var(--ol-attention)'],
  ['negative', 'var(--ol-negative)'],
  ['info', 'var(--ol-info)'],
  ['neutral', 'var(--ol-text-tertiary)'],
];

export const arrowMarker = (key: 'seq' | StatusIntent): string => `url(#ol-arrow-${key})`;
